import React from "react";
import { Link } from "react-router-dom";
import { Play, Eye, Youtube, Smartphone } from "lucide-react";

export const fmtViews = (n) => {
  if (!n) return null;
  if (n >= 1e6) return `${(n / 1e6).toFixed(1)}M`;
  if (n >= 1e3) return `${(n / 1e3).toFixed(n >= 1e4 ? 0 : 1)}K`;
  return String(n);
};

const PLATFORM = {
  youtube: { label: "YouTube", Icon: Youtube },
  tiktok: { label: "TikTok", Icon: Smartphone },
  instagram: { label: "Reels", Icon: Smartphone },
};

export const VideoCard = ({ video, index, compact = false }) => {
  const p = PLATFORM[video.platform] || PLATFORM.youtube;
  return (
    <Link to={`/videos/${video.id}`} className="card overflow-hidden group flex flex-col" data-testid={`video-card-${video.id}`}>
      <div className={`relative overflow-hidden bg-black/40 ${video.is_short ? "aspect-[9/12]" : "aspect-video"}`}>
        {video.thumbnail ? (
          <img src={video.thumbnail} alt="" loading="lazy" className="w-full h-full object-cover group-hover:scale-105 transition duration-500" />
        ) : (
          <div className="w-full h-full flex items-center justify-center text-slate-600"><p.Icon className="w-10 h-10" /></div>
        )}
        <div className="absolute inset-0 bg-gradient-to-t from-void/90 via-transparent to-transparent" />
        <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition">
          <div className="w-14 h-14 rounded-full bg-cyan1 text-void flex items-center justify-center shadow-[0_0_30px_rgba(0,240,255,0.5)]"><Play className="w-6 h-6 ml-1" fill="currentColor" /></div>
        </div>
        <div className="absolute top-3 left-3 flex gap-2">
          <span className="chip chip-cyan">{video.category}</span>
          {video.is_short && <span className="chip chip-magenta">Shorts</span>}
        </div>
        {index !== undefined && <div className="absolute top-2 right-3 font-heading text-4xl font-black text-white/10">{String(index + 1).padStart(2, "0")}</div>}
        <div className="absolute bottom-3 left-3 right-3 flex items-center justify-between text-[10px] font-mono uppercase tracking-widest text-slate-300">
          <span className="flex items-center gap-1"><p.Icon className="w-3 h-3" /> {video.channel_name}</span>
          {video.views > 0 && <span className="flex items-center gap-1"><Eye className="w-3 h-3" /> {fmtViews(video.views)}</span>}
        </div>
      </div>
      <div className={compact ? "p-4" : "p-5"}>
        <h3 className={`font-heading font-bold leading-snug line-clamp-2 group-hover:text-cyan1 transition ${compact ? "text-sm" : "text-base"}`}>{video.title}</h3>
        <div className="mt-2 text-[10px] font-mono uppercase tracking-widest text-slate-500">
          {new Date(video.published_at).toLocaleDateString("id-ID", { day: "numeric", month: "short", year: "numeric" })}
        </div>
      </div>
    </Link>
  );
};
